<template>
<div class="fill-height" style="height: 100%">
    <v-navigation-drawer flat color="grey-darken-4" v-model="layersDrawerState" :location="rightHandedLeft"
        theme="dark" width="320" class="d-flex pb-6" touchless>
        <LayersMenu @selectedBaseLayer="selectedBaseLayer" @toggleLayer="toggleLayer" 
            v-touch="{
                left: () => swipeBox(rightHandedLeft, layersDrawerState),
                right: () => swipeBox(rightHandedRight, layersDrawerState),
                }"
        />
    </v-navigation-drawer>

    <v-navigation-drawer flat color="grey-darken-4" v-model="daysDrawerState" :location="rightHandedRight"
        theme="dark" width="320" class="d-flex pb-6" touchless>
        <gathered-layers-menu v-model:trackerDaysLayers="trackerDaysLayersGEOJsons"
            v-model:phytosociologicalLayer="phytosociologicalLayerGEOJson" @zoomToLayer="zoomToLayer"
            @zoomToFeature="zoomToFeature" 
            v-touch="{
                left: () => swipeBox(rightHandedRight, daysDrawerState),
                right: () => swipeBox(rightHandedLeft, daysDrawerState),
                }"
        />
    </v-navigation-drawer>

    <v-navigation-drawer flat color="grey-darken-4" v-model="infoBoxState" :location="rightHandedLeft" theme="dark"
        absolute left top class="pa-0" touchless
        >
        <info-box :currentCenter="currentCenter" :zoom="zoomStruct" :currentResolution="currentResolution"
            :selectedOLFeature="selectedOLFeature" 
            v-touch="{
                left: () => swipeBox(rightHandedLeft, infoBoxState),
                right: () => swipeBox(rightHandedRight, infoBoxState),
                }"
            />
            <template v-slot:append>
                <v-divider />
                <v-container class="text-center">
                    <v-btn size="small"  variant="outlined" @click="infoBoxState=false">
                        <v-icon v-if="rightHandedRight=='right'"
                        >mdi-chevron-double-left</v-icon> nascondi
                        <v-icon v-if="rightHandedRight=='left'"
                        >mdi-chevron-double-right</v-icon>
                    </v-btn>
                </v-container>
            </template>
            </v-navigation-drawer>




    <ol-map id="the_map" ref="map_ref" :loadTilesWhileAnimating="false" :loadTilesWhileInteracting="true"
        :controls="[]">


        <router-view v-if="selectedOLFeature" :map="map" :vectorSelectionControl="vectorSelectionControl"
            :currentCenter="currentCenter" :selectedOLFeature="selectedOLFeature"
            :layerOfSelectedFeature="layerOfSelectedFeature" @onBackButtonIfFeatureIsNew="triggerDeleteSelectedFeature">
        </router-view>

        <div id="x_container">
            <div id="xaxis"></div>
        </div>
        <div id="y_container">
            <div id="yaxis"></div>
        </div>


        <ol-scale-line-control v-if="runtimeStore?.session?.settings?.showScaleControl" :bar="false" />


        <ol-projection-register projectionName="EPSG:32632"
            projectionDef="+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs"
            :projectionExtent="[166021.44, 0.0, 833978.56, 9329005.18]" />


        <ol-projection-register projectionName="EPSG:23032"
            projectionDef="+proj=utm +zone=32 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs"
            :projectionExtent="[-1206117.77, 3859932.9, 2582411.08, 8051813.3]" />


        <ol-projection-register projectionName="EPSG:4326" projectionDef="+proj=longlat +datum=WGS84 +no_defs"
            :projectionExtent="[-180, -90, 180, 90]" />


        <ol-view v-if="isViewReady" ref="view_ref" :enableRotation="false"
            :projection="runtimeStore.session.settings.viewProjection" :center="center" :rotation="rotation"
            :zoom="zoom" @change:center="centerChanged" @change:resolution="resolutionChanged"
            @change:rotation="rotationChanged" :extent="extent" :smoothExtentConstraint="true"
            :constrainResolution="false" :smoothResolutionConstraint="false" :showFullExtent="true" :maxZoom="maxZoom"
            :minZoom="minZoom" />



        <template>
            <vector-selection v-model:selectedOLFeature="selectedOLFeature"
                v-model:layerOfSelectedFeature="layerOfSelectedFeature" ref="vector_interaction_ref"
                @zoomToFeature="zoomToFeature">
            </vector-selection>

            <ol-interaction-pointer v-if="runtimeStore?.volatile?.location?.follow === true"
                @drag="removeFollow($event)" @down="removeFollow($event)" />
            <!-- 
            <ol-interaction-pointer v-if="selectedOLFeature" @drag="onDragWhileSelected($event)"
                @down="onDragWhileSelected($event)" /> -->
        </template>

        <!-- <AnnotazioniLayer 
            v-if="true"
            which="annotazioni_personali"
        />

        <AnnotazioniLayer 
            v-if="true"
            which="annotazioni_colleghi"
        /> -->

        <template v-for="layer, k in layers.annotazioniLayers" :key="layer.id">
            {{ console.log("rendering annotazioni layer", layer) }}
                <AnnotazioniLayer 
                    v-if="layer.visible"
                    v-model:layer="layers.annotazioniLayers[k]" 
                    :which="layers.annotazioniLayers[k].which"
                />
        </template>

        <template v-for="layer, k in layers.overlayLayers" :key="layer.id">
                <component v-if="layer.visible" :is="lookupLayerComponents[layer.component]"
                v-model:layer="layers.overlayLayers[k]" :currentCenter="currentCenter"
                :viewProjection="runtimeStore.session.settings.viewProjection" />
        </template>


        <template v-for="layer, k in layers.userLayers" :key="layer.id">
            <GeoJSONVectorLayerURL v-if="layer.visible" :is="GeoJSONVectorLayerURL" v-model:layer="layers.userLayers[k]"
                 :viewProjection="runtimeStore.session.settings.viewProjection" />
        </template>


        <vector-edit v-if="interactionMode == 'edit'" :selectedOLFeature="selectedOLFeature"
            @newGometry="newGeometry" />


        <!-- <ol-animated-clusterlayer :animationDuration="500" :distance="40"> -->
        <!-- </ol-animated-clusterlayer> -->
        <global-gather-layer name="gather" :zIndex="1100" />

        <!--         
        <template v-for="(layer, k) in trackerDaysLayersGEOJsons" :key="k">
            <day-layer v-if="layer.visible" v-model:layer="trackerDaysLayersGEOJsons[k]"
                :viewProjection="runtimeStore.session.settings.viewProjection" />
        </template> -->


        <!--         

        <day-layer v-model:layer="phytosociologicalLayerGEOJson"
            :viewProjection="runtimeStore.session.settings.viewProjection" />
 -->




        <template v-if="map">

            <template v-for="layer in layers.baseLayers" :key="layer.id">

                <template v-if="layer.type == 'tile'">
                    

                    <ol-tile-layer v-if="layer.visible" :zIndex="2">
                        <template v-if="layer.source_type == 'osm'">

                            <ol-source-osm :ref="`source_ref_${layer.id}`" crossOrigin="anonymous" />
                        </template>

                        <template v-if="layer.source_type == 'xyz'">

                            <ol-source-xyz :url="layer.url" :projection="layer.projection"
                               crossOrigin="anonymous" />
                        </template>
                    </ol-tile-layer>
                </template>
<!-- 
                <template v-if="layer.type == 'mbtiles-single-file'">
                    <mbtiles-single-file v-if="layer.visible" :layer="layer" :map="map"></mbtiles-single-file>
                </template> -->


                <template v-if="layer.type == 'pmtiles-raster'">
                    <pmtiles-raster v-if="layer.visible" :layer="layer" :map="map"></pmtiles-raster>
                </template>



                <template v-if="layer.type == 'pmtiles-vector'">
                    <pmtiles-vector v-if="layer.visible" :layer="layer" :map="map"></pmtiles-vector>
                </template>


                
                <template v-if="layer.type == 'tiles-folder'">
                    <tiles-folder v-if="layer.visible" :layer="layer" ></tiles-folder>
                </template>


            </template>
        </template>




        <template v-if="locationStore.position">
            <ol-vector-layer :zIndex="1000" :properties="(() => { return { selectable: false } })">
                <ol-source-vector :ref="`source_ref_geolocation`">
                    <ol-feature>
                        <ol-geom-point :coordinates="[
                            locationStore.byEPSG(runtimeStore.session.settings.viewProjection)[0],
                            locationStore.byEPSG(runtimeStore.session.settings.viewProjection)[1] - (7 * currentResolution)
                        ]

                            ">
                        </ol-geom-point>
                        <ol-style>
                            <ol-style-text font='normal normal normal 60px/1 "Material Design Icons"' text="󰎐"
                                fill="rgba(0,0,0,.3)" placement="point" offsetX="0" offsetY="-6"
                                :rotation="locationStore.headingRad"></ol-style-text>
                        </ol-style>
                    </ol-feature>
                    <ol-feature>
                        <ol-geom-point
                            :coordinates="locationStore.byEPSG(runtimeStore.session.settings.viewProjection)"></ol-geom-point>
                        <ol-style>
                            <ol-style-text font='normal normal normal 60px/1 "Material Design Icons"' text="󰎐"
                                :fill="arrowColor" :stroke="{
                                    color: '#fff',
                                    width: 3,
                                }" placement="point" offsetX="0" offsetY="-6"
                                :rotation="locationStore.headingRad"></ol-style-text>
                            <!-- <ol-style-icon v-if="locationStore.age < 10" :src="arrowIcon" :scale=".05"
                                :rotation="locationStore.headingRad" />
                            <ol-style-icon v-else :src="arrowGreyIcon" :scale=".05"
                                :rotation="locationStore.headingRad" /> -->
                        </ol-style>
                    </ol-feature>
                </ol-source-vector>
            </ol-vector-layer>
        </template>


        <!-- <ol-tile-layer  :zIndex="1" :opacity=".3">
                <ol-source-osm  />
        </ol-tile-layer> -->

        <div id="controls" :class="controlsDirection" v-if="map"
        
        v-show="showControls"
        >

            <div class="left align-center pa-4">

                <div class="row1">
                    <map-settings @emitChangeProjection="changeProjection" v-if="!selectedOLFeature" />
                </div>
                <div class="row2">
                    <v-fab color="blue-darken-3" dark size="large" icon="mdi-map"
                        @click="toggleLayersMenu" />
                </div>


                <div class="row3">
                    <div class="d-flex flex-column " v-if="!selectedOLFeature">

                        <v-fab v-if="runtimeStore?.session?.settings?.showZoomControl" color="grey-darken-3" class=""
                            dark size="small" icon="mdi-plus" @click="zoomIn" />
                        <v-fab v-if="runtimeStore?.session?.settings?.showZoomControl" color="grey-darken-3" class=""
                            dark size="small" icon="mdi-minus" @click="zoomOut" />

                    </div>
                </div>

            </div>

            <!-- <v-spacer /> -->
            <div class="d-flex flex-column flex-grow-1 align-center justify-start">
                <template v-if="runtimeStore.session.user.pk === 63">
                    <v-chip color="black" variant="flat" class="mb-1">
                        <v-icon class="mr-2" color="yellow-darken-2">mdi-gesture-double-tap</v-icon> {{ interactionMode
                        }}
                    </v-chip>
                    <v-chip color="black" variant="flat" class="mb-1">

                        <v-icon class="mr-2"
                            :color="selectedOLFeature?.get('uuid') ? 'yellow-darken-2' : 'grey-darken-2'">mdi-card-account-details</v-icon>
                        uuid
                        <v-tooltip activator="parent" location="bottom"
                            :open-on-click="true">{{ selectedOLFeature?.get('uuid') || 'no feature selected'}}</v-tooltip>
                    </v-chip>
                    <v-chip color="black" variant="flat" class="mb-1">
                        <v-icon class="mr-2"
                            color='yellow-darken-2'>mdi-magnify</v-icon>
                        Z>  <span class='text-yellow-darken-2'>{{ zoomStruct.current.toFixed(2) }}</span> ({{ zoomStruct.minzoom }}-{{ zoomStruct.maxzoom }})<br>
                    </v-chip>

                    <v-chip color="black" variant="flat" class="mb-1">
                        <v-icon class="mr-2"
                            color='yellow-darken-2'>mdi-grid</v-icon>
                        R>  <span class='text-yellow-darken-2'>{{ currentResolution .toFixed(2)}}</span>
                    </v-chip>
                </template>
            </div>

            <div class="right">

                <div class="row1 ">

                    <v-fab v-if="runtimeStore?.session?.settings?.showInfoPosition" dark size="default"
                        :color="infoBoxState ? 'blue' : 'grey-darken-2'" :border="'2px solid white'"
                        icon="mdi-information-outline" @click="togglePositionBox" />
                    <tele-porter v-if="runtimeStore?.session?.settings?.showTeleporter" v-model="goTo"
                        @update:model-value="changeCenter" />
                    <v-fab dark v-if="!isGeoLocationInsideView" color='yellow-darken-3'
                        @click="goToGeolocated" icon="mdi-navigation" size="default"
                        :style="`transform: rotate(${locationStore?.position?.coords?.heading}deg)`" />
                    <template v-else>
                        <v-fab v-if='runtimeStore?.volatile?.location?.follow === true' dark
                            color='yellow-darken-3' @click="toggleFollow" icon="mdi-lock" size="default" />
                        <v-fab v-else dark color='grey-darken-2' @click="toggleFollow" icon="mdi-lock-off"
                            size="default" />
                    </template>
                </div>
                <div class="row2">
                    <v-btn color="red-darken-3" dark size="large" absolute icon="mdi-sack"
                        @click="toggleDaysMenu" />
                </div>
                <div class="row3">
                    <template v-if="showInsertNewFeature">
                        <file-input class="d-flex justify-center"
                            v-if="runtimeStore?.session?.settings?.showQuickAddMedia" @onFileAdded="fileAdded"
                            :config="mapFileInputQuickMedia" />

                        <insert-chooser-bottom @onInsert="insertNewFeature" v-if="insideActiveBounds" />
                        <!-- <insert-chooser @onInsert="insertNewFeature" v-if="insideActiveBounds" /> -->
                        <v-fab v-else color="grey-darken-2" dark size="large" icon="mdi-plus"
                            @click="denyInsert" />
                    </template>
                    <!-- <template v-else>
                        <v-fab id="insert_media_placeholder" color="grey" size="large" icon="mdi-plus"
                            v-if="runtimeStore?.session?.settings?.showQuickAddMedia"
                            style="opacity: 0; pointer-events: none" />
                        <v-fab id="insert_feature_placeholder" color="grey" size="large" icon="mdi-plus"
                            style="opacity: 0; pointer-events: none" />
                    </template> -->
                </div>
            </div>
        </div>

        <v-slide-y-reverse-transition>

            <v-card id="bottomSheet" v-if="selectedOLFeature && interactionMode == 'select'" theme="dark" :rounded="0"
                class="" style="">
                <v-container id="ribbon" class="pa-0 ma-0" fluid></v-container>

                <v-card-text class="d-flex justify-space-between align-center">
                    <!-- <div v-if="selectedOLFeature?.properties?.model" -->
                    <div v-if="selectedOLFeature.get('model')" class="d-flex justify-center align-center flex-grow-1">

                        <template v-if="true">

                            <v-dialog width="auto">
                                <template v-slot:activator="{ props }">
                                    <v-btn color='red-darken-3' class="mx-2" icon="mdi-delete"
                                        size="default" v-bind="props" id="deleteFeatureButton"></v-btn>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card theme="dark">
                                        <v-card-item>
                                            <v-card-title>Eliminazione</v-card-title>
                                            <v-card-subtitle>Stai per eliminare un oggetto</v-card-subtitle>
                                        </v-card-item>
                                        <v-card-text>
                                            <p class="mb-2">
                                                Sei davvero sicuro di voler eliminare<br> l'<strong>oggetto
                                                    selezionato</strong> (e i
                                                <strong>media collegati</strong>),
                                                <!-- <template v-if="selectedOLFeature.get('state') !== 201">
                                        <br>nonostante non sia stato caricato?
                                    </template> -->
                                            </p>
                                        </v-card-text>

                                        <v-card-actions class="d-flex flex-column align-center ">
                                            <v-btn variant="flat" size="large" color="red-darken-2"
                                                class="my-1" @click="deleteFeature(); isActive.value = false;">
                                                <v-icon>mdi-delete</v-icon>
                                                Elimina</v-btn>
                                            <v-btn variant="outlined" size="large" color="white"
                                                class="my-1 mx-0" @click="isActive.value = false;">
                                                <v-icon>mdi-chevron-down</v-icon>
                                                Indietro</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>

                        </template>

                        <template v-if="areFeaturePropertiesEditable(selectedOLFeature)">
                            <v-btn color='orange-darken-3' class="mx-2" icon="mdi-pencil" size="default"
                                :to="'/map/feature/edit/?uuid=' + selectedOLFeature.get('uuid')" />
                        </template>

                        <template v-if="isGeometryFeatureEditable(selectedOLFeature)">
                            <v-btn color='lime-darken-3' class="mx-2" icon="mdi-android-studio"
                                size="default" @click="editFeature" />
                        </template>
                        <v-btn color='blue-darken-4' class="mx-2" icon="mdi-eye" size="default"
                            :to="'/map/feature/view/?uuid=' + selectedOLFeature.get('uuid')" />
                        <!-- <v-btn color='orange-darken-3' class="mx-2" icon="mdi-arrow-all" size="default"
            disabled />
        <v-btn color='orange-darken-3' class="mx-2" icon="mdi-vector-polygon" size="default"
            disabled /> -->
                    </div>
                </v-card-text>

                <v-card-item class="">
                    <div class="d-flex flex-row justify-space-between" style="width: 100%">
                        <v-btn v-if="true" color='blue-grey-darken-3' icon="mdi-arrow-left" size="default"
                            class="mx-2" @click="prevFeature" />
                        <v-spacer />
                        <div class="" style="min-width: 0">
                            <v-card-title class="text-center" style="text-overflow: ellipsis;">{{ bottomTitle
                                }}
                            </v-card-title>
                            <v-card-subtitle class="text-center">
                                <template v-if="selectedOLFeature.get('state') === 201">
                                    <v-icon size="small" class="mb-1 mr-2"
                                        color="green-lighten-2">mdi-cloud-check</v-icon>
                                </template>
                                {{ bottomSubTitle }}</v-card-subtitle>
                        </div>
                        <v-spacer />

                        <v-btn v-if="true" color='blue-grey-darken-3' icon="mdi-arrow-right"
                            size="default" class="mx-2" @click="nextFeature" />
                    </div>
                </v-card-item>
            </v-card>
        </v-slide-y-reverse-transition>


    </ol-map>
    </div>
</template>

<script setup>
import { ref, computed, onBeforeMount, onMounted, onUnmounted, watch, markRaw, nextTick, provide, inject} from "vue";
import { useRuntimeStore } from "@/store/runtime"
import { useLocationStore } from "@/store/location";
import { useMapStore } from "@/store/map";
import { useDataStore } from "@/store/data";
import GatheredLayersMenu from "@/components/map/GatheredLayersMenu";
import { useDisplay } from "vuetify";
import AnnotazioniLayer from "@/components/map/layers/AnnotazioniLayer";
const { mobile, } = useDisplay();


import LayersMenu from "@/components/map/LayersMenu";
import TelePorter from "@/components/map/TelePorter";
import VectorSelection from "@/components/map/VectorSelection";
import VectorEdit from "@/components/map/VectorEdit";
import InsertChooserBottom from "@/components/map/InsertChooserBottom";
import InfoBox from "@/components/map/InfoBox";
import MapSettings from "@/components/map/MapSettings";
import { transform, toLonLat } from 'ol/proj';
// import Projection from 'ol/proj/Projection.js';

import * as olExtent from 'ol/extent';
// import { useRoute } from 'vue-router'
import router from "@/router";
import { useRoute } from 'vue-router'


import { WGS84UTM32_to_UTMPNGP250 } from '@/components/map/utils/UTMPNGP250'

import { WGS84UTM32_to_UTM4k } from '@/components/map/utils/UTM4k'

import VectorLayer from "ol/layer/Vector";


import GlobalGatherLayer from "@/components/map/layers/GlobalGatherLayer";
//import PhytosociologicalLayer from "@/components/map/layers/PhytosociologicalLayer";
import layerQ250 from "@/components/map/layers/QuadL250";
import GeoJSONVectorLayerURL from "@/components/map/layers/GeoJSONVectorLayerURL";
import GeoJSONVectorIbexPreviousMonth from "@/components/map/layers/GeoJSONVectorIbexPreviousMonth";

// import MbtilesSingleFile from "@/components/map/layers/MbtilesSingleFile";
import PmtilesRaster from "@/components/map/layers/PmtilesRaster";
import PmtilesVector from "@/components/map/layers/PmtilesVector";
import TilesFolder from "@/components/map/layers/TilesFolder";

import FileInput from '@/components/media/FileInput.vue'


import GeoJSON from 'ol/format/GeoJSON.js'

// import pngpgeojson from '@/assets/geojson/confinepngp_epsg3857.json'
import insert_bounds from '@/assets/geojson/insert_bounds_4326.json'


import { easeOut } from 'ol/easing.js';


import { useToastsStore } from "@/store/toasts";

// import { isProxy, toRaw } from 'vue';


import { useFilesStore } from "@/store/files";
const filesStore = useFilesStore();


// import { VFab } from 'vuetify/labs/VFab'


const toastsStore = useToastsStore();

const lookupLayerComponents = {
    // DynamicVectorLayer: markRaw(DynamicVectorLayer),
    layerQ250: markRaw(layerQ250),
    GeoJSONVectorLayerURL: markRaw(GeoJSONVectorLayerURL),
    GeoJSONVectorIbexPreviousMonth: markRaw(GeoJSONVectorIbexPreviousMonth),
    // MbtilesSingleFile: markRaw(MbtilesSingleFile),
    PmtilesRaster: markRaw(PmtilesRaster),
    PmtilesVector: markRaw(PmtilesVector),
    TilesFolder: markRaw(TilesFolder),
}


const windowSize = inject("windowSize")

const infoBoxWidth = computed(() => {
    if (!mobile.value) return "0"
    if (mobile.value) return "" + windowSize.width
})

const view_ref = ref({})
const vector_interaction_ref = ref(null)

const map_ref = ref(null);



const controlsDirection = computed(() => {
    if (runtimeStore.session.settings.hand == "right")
        return null
    else
        return "flex-row-reverse"
})

const rightHandedRight = computed(() => {
    if (runtimeStore.session.settings.hand == "right")
        return "right"
    return "left"
})

const rightHandedLeft = computed(() => {
    if (runtimeStore.session.settings.hand == "right")
        return "left"
    return "right"
})

const layersDrawerState = ref(false)
const daysDrawerState = ref(false)
// const phytoDrawer = ref({
//    false
// })

const infoBoxState = ref(false)

// const packsStore = usePacksStore()

const runtimeStore = useRuntimeStore()
const locationStore = useLocationStore()
const dataStore = useDataStore()
const mapStore = useMapStore()

const goTo = ref(null)

const center = ref([798772.06, 5706198.7]
)
const zoom = ref(16)
const maxZoom = ref(19)
const minZoom = ref(4)
const rotation = ref(0)


const currentCenter = {
    epsg3857: ref([0, 0]),
    epsg4326: ref([0, 0]),
    epsg32632: ref([0, 0]),
    q250: ref(-1),
    quadUTM: ref(-1),
}


const selectedOLFeature = ref(null);

// const currendDataFeatureSelected = computed(() => {
//     if (!selectedOLFeature.value) return null


// const rawFeature = isProxy(selectedOLFeature.value) ? toRaw(selectedOLFeature.value) : selectedOLFeature.value

//     const {node, feature} = dataStore.getDataFromFeatureUUID(
//         rawFeature.get("uuid")
//     )
//     return feature
// })


const layerOfSelectedFeature = ref(null);

const selectedOLFeatureTitle = computed(() => {

    // console.log(selectedOLFeature)

    const sOLF = selectedOLFeature.value

    let title = null
    if (!sOLF) return title

    if (!title)
        title = sOLF.get('label');
    if (!title)
        title = sOLF.get('title');
    if (!title)
        title = sOLF.get('label');
    if (!title)
        title = sOLF.get('name');
    if (!title)
        title = sOLF.get('nome');
    if (!title)
        title = sOLF.get('slug');
    if (!title)
        title = sOLF.get('model');
    if (!title)
        title = sOLF.get('codice');
    if (!title)
        title = sOLF.get('id');
    if (!title)
        title = "-";


    if (sOLF?.get('amount') && sOLF?.get('user') && sOLF?.get('timestamp')) {
        title = ""
        title += "Stambecchi:  " + sOLF?.get('amount')
        // title += " - " + sOLF?.get('user')
        // title += " | " + sOLF?.get('timestamp').split("-").reverse().join("/")
    }


    return title
})



const showControls = computed(() => {
    // console.log("infoBoxState",infoBoxState.value)
    // console.log("mobile",mobile.value)
    if (!infoBoxState.value) return true
    if (infoBoxState.value && mobile.value) return false
    return true
})

const bottomTitle = computed(() => {
    let title = ""
    // title = `${selectedOLFeatureTitle.value} (${layerOfSelectedFeature.value.get("name")}) z${layerOfSelectedFeature.value.get("zIndex")}`    
    title = `${selectedOLFeatureTitle.value}`
    return title
})
const bottomSubTitle = computed(() => {

    const sOLF = selectedOLFeature.value

    if (sOLF?.get('amount') && sOLF?.get('user') && sOLF?.get('timestamp')) {
        return sOLF?.get('timestamp').split("-").reverse().join("/")
    }

    const data = dataStore.getDataFromFeatureUUID(sOLF.get("uuid"))
    return data?.node?.name.split("-").reverse().join("/")
    // [dataStore.trackerTodayName, 'phytosociological'].includes(layerOfSelectedFeature.get('name'))

})


const isGeoLocationInsideView = computed(() => {

    if (!locationStore.position) return false
    if (!view_ref.value) return false

    const viewExtent = view_ref.value.calculateExtent()
    // console.log(viewExtent)

    const coords = locationStore.coordinates3857

    if (
        coords[0] >= viewExtent[0] &&
        coords[0] <= viewExtent[2] &&
        coords[1] >= viewExtent[1] &&
        coords[1] <= viewExtent[3]
    ) {
        return true
    }


    return false
    // ol.extent.containsExtent(extent, feature.getGeometry().getExtent())
})





const zoomStruct = ref({
    current: zoom.value,
    maxzoom: maxZoom.value,
    minzoom: minZoom.value,
});
const currentRotation = ref(rotation.value);
const currentResolution = ref(0);

const resolutionChanged = (event) => {
    currentResolution.value = event.target.getResolution();
    zoomStruct.value.current = event.target.getZoom();

}

let resetTimeout = null;


let canCenterChange = true
const lockCenterChangesForAwhile = () => {
    canCenterChange = false
    setTimeout(() => {
        canCenterChange = true
    }, 50)
}

const centerChanged = (event) => {

    if (canCenterChange === false) {
        return
    }
    lockCenterChangesForAwhile()

    if (runtimeStore?.volatile?.location?.follow === true) {
        if (view_ref.value.getCenter() != locationStore.byEPSG(runtimeStore.session.settings.viewProjection)) {

            if (resetTimeout) {
                clearTimeout(resetTimeout)
            }
            resetTimeout = setTimeout(() => {
                view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))
                // console.log("reset center to geolocation")
            }, 50)

        }
    }

    // console.log(center.value)

    // debugger

    // const prj3857 = new Projection('EPSG:3857')
    // const prj32632 = new Projection('EPSG:32632')

    const tmpCenter3857 = event.target.getCenter();
    const tmpCenter4326 = toLonLat(tmpCenter3857, 'EPSG:3857')
    const tmpCenter32632 = transform(tmpCenter3857, "EPSG:3857", "EPSG:32632")



    currentCenter.epsg3857.value = [
        parseFloat(tmpCenter3857[0].toFixed(2)),
        parseFloat(tmpCenter3857[1].toFixed(2)),
    ]

    currentCenter.epsg4326.value = [
        // inverted
        parseFloat(tmpCenter4326[0].toFixed(7)),
        parseFloat(tmpCenter4326[1].toFixed(7)),
    ]
    currentCenter.epsg32632.value = [
        parseFloat(tmpCenter32632[0].toFixed(2)),
        parseFloat(tmpCenter32632[1].toFixed(2)),
    ]

    currentCenter.q250.value = WGS84UTM32_to_UTMPNGP250(
        currentCenter.epsg32632.value[0],
        currentCenter.epsg32632.value[1]
    )

    currentCenter.quadUTM.value = WGS84UTM32_to_UTM4k(
        currentCenter.epsg32632.value[0],
        currentCenter.epsg32632.value[1]
    )

}

function rotationChanged(event) {
    currentRotation.value = event.target.getRotation();
}


let map = ref(null);
let vectorSelectionControl = ref(null);

// provide("map", map)
// provide("vectorSelectionControl", vectorSelectionControl)

// const dragMapEvent = new Event("dragend");

let saveCenterAndZoomInterval = null

const isViewReady = ref(true)





const initMap = async () => {

    // console.log(map_ref.value);
    if (map_ref.value) {
        // Component instance is active, proceed with your logic
        // console.log('map_ref is mounted!');
    }
    console.log("🌍 init map")

    map.value = map_ref.value.map;
    console.log("🌍 ", map_ref)

    map.value.getView().on('change:resolution', resolutionChanged);
    map.value.getView().on('change:center', centerChanged);
    map.value.getView().on('change:rotation', rotationChanged);

    map.value.getView().on('click', () => { console.log("clicked") });


    vectorSelectionControl.value = vector_interaction_ref.value;

    view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))

    if (runtimeStore.session.map.center) {
        // console.log(runtimeStore.session.map.center)
        // console.log(runtimeStore.session.map.center["epsg3857"])

        if (runtimeStore?.session?.map?.center?.epsg3857) {
            view_ref.value.setCenter(runtimeStore.session.map.center.epsg3857)
        }

    }

    if (runtimeStore?.session?.map?.zoom) {
        view_ref.value.setZoom(runtimeStore.session.map.zoom)
    }

    saveCenterAndZoomInterval = setInterval(saveCenterAndZoom, 20*1000);


    await nextTick(() => {
        // isViewReady.value = true
        // change #the_map (scoped) aka  map_ref

    })
    manageUrlParams()


    console.log("🖐🖐🖐 !!!interactionMode: ", interactionMode.value)


};



onBeforeMount(() => {
    mapStore.refreshLayers()
})


onUnmounted(() => {
    clearInterval(saveCenterAndZoomInterval)
}
)

onMounted(() => {

    // initMap()

//    console.log(map_ref.value)


    setTimeout(initMap, 200);
})


const saveCenterAndZoom = () => {


    if (
        runtimeStore.session.map.zoom == zoomStruct.value.current &&
        runtimeStore.session.map.center.epsg3857[0] == currentCenter.epsg3857.value[0] &&
        runtimeStore.session.map.center.epsg3857[1] == currentCenter.epsg3857.value[1]
    ) {
        // no changes, no save
        console.log(" no changes, no save")
        return
    }



    // console.log(runtimeStore.session.map.zoom)

    // console.log(runtimeStore.session.map.center.epsg3857)
    // console.log(JSON.parse(JSON.stringify(currentCenter.value.epsg3857)))


    runtimeStore.session.map.zoom = JSON.parse(JSON.stringify(zoomStruct.value.current))
    runtimeStore.session.map.center = JSON.parse(JSON.stringify({
        epsg3857: currentCenter.epsg3857.value,
        epsg4326: currentCenter.epsg4326.value,
        epsg32632: currentCenter.epsg32632.value,
        q250: currentCenter.q250.value,
        quadUTM: currentCenter.quadUTM.value,
    }))

    console.log("🌍 saving map changes (each 20 s)")
    runtimeStore.saveSession()
}


const extent = computed(() => {

    if (runtimeStore?.session?.settings?.mapExtentLocked === false) {
        return undefined
    }

    // let extent = undefined

    // const possibleExtents = {

    //     vda_pngp: [
    //         743704.9350160131,
    //         5682488.50614157,
    //         889832.8125000003,
    //         5781788.500000005,   // vda + pngp
    //     ],

    //     vda: [
    //         756122.5583561556413770,  // VDA (da buffer 1000)
    //         5694339.8545881686732173,
    //         884815.7731914874166250,
    //         5779357.9045197339728475,
    //     ],

    //     pngp: [
    //         785929.2776999998604879,  // PNGP (da buffer 1000)
    //         5683642.0890000006183982,
    //         844571.6681999996071681,
    //         5730498.0452999928966165
    //     ]
    // }

    // if (runtimeStore?.session?.settings?.mapExtentLocked) {
    //     extent = possibleExtents["vda_pngp"]
    // }

    // debugger
    activeBounds.value.scale(1.3)
    return activeBounds.value.getExtent()
    // return extent

})



const arrowColor = computed(() => {
    const age = locationStore.age > 20 ? 20 : locationStore.age

    const color = runtimeStore?.session?.settings?.arrowColor || `rgba(21,192,101,1)`

    const r = 21 - (21 * age / 20)
    const g = 192 - (192 * age / 20)
    const b = 101 - (101 * age / 20)
    const a = 1 - (.3 * age / 20)

    // const color = `rgba(${r},${g},${b},${a})`
    return color
})


const zoomIn = () => {
    view_ref.value.setZoom(view_ref.value.getZoom() + 1)
}
const zoomOut = () => {
    view_ref.value.setZoom(view_ref.value.getZoom() - 1)
}

const changeProjection = () => {
    isViewReady.value = false
    setTimeout(() => {
        runtimeStore.saveSession()
        isViewReady.value = true
    }, 1000);
}


watch(() => locationStore.position, (newVal, oldVal) => {
    // console.log("locationStore.position", newVal);
    if (runtimeStore?.volatile?.location?.follow !== true) {
        // console.log("non seguo");
        return false
    }
    if (newVal != oldVal) {
        // console.log(view_ref);

        view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))
        // view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))
        runtimeStore.session.map.location.last = locationStore.position
    }
})


const deleteConfirm = ref(false)

const denyInsert = () => {
    toastsStore.toast({
        title: "Fuori dal confine",
        text: "Il punto di inserimento (centro mappa) è fuori dal confine.",
        type: "warning",
    })
}

const deleteFeature = async () => {

    const uuid = selectedOLFeature.value.get("uuid")
    let howManyConnectedFiles = 0
    if (uuid) {
        howManyConnectedFiles = await filesStore.deleteByFilter(
            { target_uuid: uuid }
        )
    }


    dataStore.deleteTrackerFeature(selectedOLFeature.value, layerOfSelectedFeature.value)
    vector_interaction_ref.value.actions.clearSelection()
    deleteConfirm.value = false


    toastsStore.toast({
        title: `Feature`,
        text: `Eliminazione confermata.`,
        type: "success",
        duration: 8000,
    })

    if (howManyConnectedFiles > 0) {

        toastsStore.toast({
            title: `Files`,
            text: `Rimossi ${howManyConnectedFiles} media collegati alla feature.`,
            type: "info",
        })
    }

}


const togglePositionBox = () => {
    infoBoxState.value = !infoBoxState.value;
}
const toggleLayersMenu = () => {
    layersDrawerState.value = !layersDrawerState.value;
    daysDrawerState.value = false
    // phytoDrawer.value.visible = false
}
const toggleDaysMenu = () => {
    daysDrawerState.value = !daysDrawerState.value;
    layersDrawerState.value = false
    // phytoDrawer.value.visible = false
}



const changeCenter = (newCenter) => {
    runtimeStore.setFollowFalse()
    // console.log("changeCenter", newCenter);
    // view_ref.value.setCenter(newCenter)

    console.log("zoomStruct", zoomStruct.value);
    let newZoom = zoomStruct.value.current + 1

    if (newZoom > maxZoom.value.current) {
        newZoom = maxZoom.value.current
    }
    console.log("newZoom", newZoom);

    zoomTo({
        zoom: newZoom,
        center: newCenter
    });


    goTo.value = null
}


const toggleFollow = () => {
    runtimeStore.mapToggleFollow()

    if (runtimeStore?.volatile?.location?.follow === true) {
        // console.log("reset center to geolocation")
        view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))
    }

}



const goToGeolocated = () => {
    view_ref.value.setCenter(locationStore.byEPSG(runtimeStore.session.settings.viewProjection))
}




const layers = mapStore.layers

// console.log(layers)

// console.dir("dataStore.userData ===")
// console.dir(dataStore.userData)

const trackerDaysLayersGEOJsons = dataStore.userData?.tracker?.days || []


const phytosociologicalLayerGEOJson = dataStore.userData?.phytosociological || null


const axisStrokeWidthPx = computed(() => {
    let width = 1
    if (runtimeStore.session?.settings?.crossWidth) {
        width = runtimeStore.session.settings.crossWidth
    }
    return width + "px"
})

const crossColor = computed(() => {
    let color = "#FFFFFF"
    if (runtimeStore.session?.settings?.crossColor) {
        color = runtimeStore.session.settings.crossColor
    }
    return color
})


const zoomTo = (options) => {
    view_ref.value.animate(options);
}

// const zoomToLayer = (layer) => {
//     console.log("zoomToLayer")
//     return
//     // console.log("zooming to first feature")
//     if (layer.features.length > 0) {
//         // const coords3857 = toLonLat(layer.features[0].geometry.coordinates, 'EPSG:3857')
//         const coords3857 = transform(layer.features[0].geometry.coordinates, "EPSG:4326", "EPSG:3857")


//         zoomTo({
//             zoom: 15,
//             center: coords3857
//         });
//     }
// }

const zoomToLayer = (layer) => {
    // console.log(layer)
    // console.log("zooming to first feature")
    if (layer.features.length > 0) {
        // const coords3857 = toLonLat(layer.features[0].geometry.coordinates, 'EPSG:3857')
        zoomToFeature(layer.features[0].properties.uuid)
    }
}




const zoomToFeature = (feature_or_uuid, options = {}) => {

    let feature = feature_or_uuid

    if (typeof feature === "string") {
        const lnf = getOLLayerAndFeatureFromUUID(feature)
        if (lnf) {
            feature = lnf.olFeature
        }
    }

    // console.log(feature)

    runtimeStore.setFollowFalse()
    // debugger
    // console.log("centerOnFeature")
    // console.log(feature)
    const featureExtent = feature.getGeometry().getExtent()

    options.center = olExtent.getCenter(featureExtent),
        options.duration = 200,
        options.easing = easeOut,

        zoomTo(options)
};






const getLayerByName = (name) => {
    let layer = null

    // console.log(map.value.getLayers())

    map.value.getLayers().forEach(function (el) {
        // console.log(el.get('name'))
        if (el.get('name') === name) {
            layer = el
        }
    })
    if (layer)
        console.log("layerFound", layer.get('name'))
    return layer
}


const InsertBoundsGeometry = new GeoJSON().readFeatures(insert_bounds, {
    featureProjection: "EPSG:3857",
    dataProjection: "EPSG:4326",
})[0].getGeometry();


const activeBounds = computed(() => {
    const bounds = InsertBoundsGeometry
    return bounds
})

const insideActiveBounds = computed(() => {

    const intersecting = activeBounds.value.intersectsCoordinate(currentCenter.epsg3857.value)
    // console.log("currentCenter.x", currentCenter.epsg3857.value[0])
    // console.log("currentCenter.y", currentCenter.epsg3857.value[1])
    // console.log("intersecting", intersecting)

    return intersecting

    // is current center inside target polygon ?
})

const showInsertNewFeature = computed(() => {

    if (selectedOLFeature.value) return false

    return true
})

const insertNewFeature = async (possibilita) => {

    console.log(possibilita)

    const instantLocation = JSON.parse(JSON.stringify(locationStore.position))

    const userPk = runtimeStore?.session?.user?.pk
    // const trackerDaysLayersGEOJsons = dataStore.userData.tracker.days


    const geometry = {
        type: "Point",
        coordinates: [
            // currentCenter.value.epsg3857[0],
            // currentCenter.value.epsg3857[1],
            currentCenter.epsg4326.value[0],
            currentCenter.epsg4326.value[1],
        ]
    }


    // const tmpCenter4326 = toLonLat(tmpCenter3857, 'EPSG:3857')
    // const tmpCenter32632 = transform(tmpCenter3857, "EPSG:3857", "EPSG:32632")
    // currentCenter.epsg3857


    const view_ext_geom = map.value.getView().calculateExtent(map.value.getSize())
    // 0
    // : 
    // 796802.6121930898
    // 1
    // : 
    // 5705170.383103851
    // 2
    // : 
    // 800741.5078069103
    // 3
    // : 
    // 5707227.016896149

    console.log(view_ext_geom)
    const xSide = view_ext_geom[2] - view_ext_geom[0]
    const ySide = view_ext_geom[3] - view_ext_geom[1]
    const shorter = xSide < ySide ? xSide : ySide

    // const halfDimension = shorter / 4
    const halfDimension = 100// 50m




    if (possibilita.geometryType === "Point") { // dont change 
    }

    if (possibilita.geometryType === "LineString") {
        geometry.type = "LineString"



        const point1 = toLonLat([
            currentCenter.epsg3857.value[0] - halfDimension,
            currentCenter.epsg3857.value[1] - halfDimension,
        ], 'EPSG:3857')
        const point2 = toLonLat([
            currentCenter.epsg3857.value[0] + halfDimension,
            currentCenter.epsg3857.value[1] + halfDimension,
        ], 'EPSG:3857')
        geometry.coordinates = [
            point1,
            point2,
        ]
    }

    if (possibilita.geometryType === "Polygon") {
        geometry.type = "Polygon"



        // put a square around the center, 100m x 100m

        const point1 = toLonLat([
            currentCenter.epsg3857.value[0] - halfDimension,
            currentCenter.epsg3857.value[1] - halfDimension,
        ], 'EPSG:3857')
        const point2 = toLonLat([
            currentCenter.epsg3857.value[0] - halfDimension,
            currentCenter.epsg3857.value[1] + halfDimension,
        ], 'EPSG:3857')
        const point3 = toLonLat([
            currentCenter.epsg3857.value[0] + halfDimension,
            currentCenter.epsg3857.value[1] + halfDimension,
        ], 'EPSG:3857')
        const point4 = toLonLat([
            currentCenter.epsg3857.value[0] + halfDimension,
            currentCenter.epsg3857.value[1] - halfDimension,
        ], 'EPSG:3857')

        geometry.coordinates = [[
            point1,
            point2,
            point3,
            point4,
            point1,
        ]]

        console.log(geometry.coordinates)

    }

    const newFeatureData =
    {
        type: "Feature",
        properties: {
            real_timestamp: Date.now(),
            timestamp: Date.now(),
            lon: currentCenter.epsg4326.value[0],
            lat: currentCenter.epsg4326.value[1],
            alt: 0,
            gps_lat: instantLocation.coords.latitude,
            gps_timestamp: instantLocation.timestamp,
            gps_lon: instantLocation.coords.longitude,
            gps_alt: instantLocation.coords.altitude,
            gps_precision: instantLocation.coords.accuracy,
            segnalatore_id: userPk,
            model: possibilita.modelCamel,
            media: "",
            possibilita_id: possibilita.id
        },
        geometry: geometry
    }



    console.log("rendere visibile il nodo fito in dataStore!!!")
    if (possibilita.modelCamel == 'PhytoSociological') {
        phytosociologicalLayerGEOJson.visible = true
    }

    let lastFeatureAdded = null
    let targetLayer = null

    // console.log("➕ feature incoming")

    const addResult = dataStore.addTrackerFeature(newFeatureData)

    console.log("➕ feature added")
    console.log(addResult)

    await nextTick()  // wait for the layer to be created

    console.log("=======================")
    console.log("just added: " + addResult.uuid)
    targetLayer = getLayerByName("gather")

    // targetLayer = getLayerByName(addResult.layerName)
    console.log(targetLayer)
    lastFeatureAdded = null

    await nextTick()  // wait for the layer to be updated

    for (const feature of targetLayer.get("source").getFeatures()) {
        // console.log("is this? :" + feature.get("uuid"))
        if (feature.get("uuid") == addResult.uuid) {
            lastFeatureAdded = feature
            console.log("found :", feature)
            console.log("found geometry :", feature.getGeometry())

            break
        }
    }

    console.log(lastFeatureAdded)

    console.log("lastFeatureAdded", lastFeatureAdded)
    console.log("targetLayer", targetLayer)

    if (!lastFeatureAdded) {
        console.error("error, lastFeatureAdded not found")
        return false
    }

    // await nextTick()
    // await nextTick()  

    // vectorSelectionControl.value.actions.selectFeature(targetLayer, lastFeatureAdded)

    await nextTick()

    await nextTick()

    vectorSelectionControl.value.actions.selectFeature(lastFeatureAdded)

    // router.push({ name: "tracker-feature-edit" });

    await nextTick()



    console.log("pusho ora")
    router.push(
        {
            name: "tracker-feature-edit",
            query: {
                uuid: lastFeatureAdded.get("uuid"),
                new: true
            }
        });



}


const selectedBaseLayer = (layer) => {
    // console.log('selectedBaseLayer', layer)

    if (layer.visible) return

    for (let l of layers.baseLayers) {
        l.visible = false
    }
    layer.visible = true

    console.log("=======================")
    console.log(layer)

    mapStore.saveLayers()

}

const toggleLayer = (layer) => {
    // console.log('toggleLayer', layer)
    
    layer.visible = !layer.visible
    map.value.render()
    // console.log(layer)
    mapStore.saveLayers()
}

const getOLLayerAndFeatureFromUUID = (uuid) => {

    const layers = map.value.getLayers().getArray().filter((layer) => layer instanceof VectorLayer)
    // cerco solo nei VectorLayers

    // console.log("🍰 ",layers)
    for (const layer of layers) {
        // console.log("🍰 ",layer)
        const olFeatures = layer?.getSource()?.getFeatures() || []
        for (const olFeature of olFeatures) {
            if (olFeature.get("uuid") === uuid) {
                // console.log("🍰 ","📅 feature found in ", layer.get("name"))
                return {
                    olFeature: olFeature,
                    olLayer: layer,
                }
            }
        }
    }

    return false

}




const triggerDeleteSelectedFeature = async (uuid) => {
    // const foundData = dataStore.getDataFromFeatureUUID(uuid)
    const found = getOLLayerAndFeatureFromUUID(uuid)
    const foundOLFeature = found.olFeature
    vectorSelectionControl.value.actions.selectFeature(foundOLFeature)

    await nextTick()
    // debugger
    // setTimeout(() => {
    //     debugger
    const deleteFeatureButton = document.getElementById("deleteFeatureButton");
    deleteFeatureButton.click()
    console.log("delete feature triggered from event emitted")
    // }, 2000);


}


const fileAdded = (name) => {
    console.log("fileAdded", name)
}
const mapFileInputQuickMedia = {
    fab: true,
    file: {
        audio: false,
        video: false,
        image: false,
        geojson: false,
    },
    capture: {
        audio: true,
        video: true,
        image: true,
    },
}




const scaleline = computed(() => {
    let style = {}
    if (runtimeStore?.session?.settings?.hand == "right") {
        style.left = "50%"
        style.transform = "translateX(-50%)"

        style.right = "auto"
    }
    else {
        style.left = "50%"
        style.transform = "translateX(-50%)"
        style.right = "auto"
    }
    return style
})



// http://picker.localhost:3000/map/?featureuuid=a165fcf3-3b66-4f1b-81d4-79c499248585&action=view
// http://picker.localhost:3000/map/?featureuuid=02f68b86-cd88-472d-8799-ceb0bac630d1&action=view
// get param from url



const route = useRoute()

watch(route, (newValue, oldValue) => {
    manageUrlParams()
});


const manageUrlParams = async () => {

    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('uuid')
    const coord0 = urlParams.get('coord0')
    const coord1 = urlParams.get('coord1')
    const zoom = urlParams.get('zoom')
    const epsg = urlParams.get('epsg')


    let found = false

    if (uuid) { 
        found = await manageUUID(uuid)
        console.log("🌍 found by uuid", found)

    }

    if (found == false) {
        if (coord0 && coord1 && epsg) {
            found = await manageCoords([coord0, coord1], zoom, epsg)
            console.log("🌍 go by coords", found)
        }
    }

    if (!found) {
        console.log("🌍 not found", found)

        router.push({ name: "map" })
    }


}

const manageUUID = async (uuid) => {

    // console.log("📍 remember to zoom to feature")


    let foundData = null
    let foundOLFeature = null
    let foundOLLayer = null
    let found = false

    if (uuid) {
        console.log("🌍 url params found")
        console.log("🌍 " + uuid)
        foundData = dataStore.getDataFromFeatureUUID(uuid)

        if (!foundData) {
            console.log("🌍 feature not found")
            router.push({ name: "map" });

            toastsStore.toast({
                title: `Feature non trovata`,
                text: "La feature con uuid:\n"+uuid+"\nnon è stata trovata.",
                type: "warning",
                dismissByUser: true,
            })
            return false
        }

        console.log("🌍 ", foundData)


        // show layer if layer of foundData is hidden
        if (foundData.node.name === "phytosociological") {
            phytosociologicalLayerGEOJson.visible = true
        }
        else
         {   
            if (trackerDaysLayersGEOJsons?.[foundData.node.name]){

                trackerDaysLayersGEOJsons[foundData.node.name].visible = true
            }
            else {
                console.log(`data layer ${foundData.node.name} not found`)
            }
        }


        await nextTick(() => { })


        found = getOLLayerAndFeatureFromUUID(uuid)
        if (!found) {
            return false
        }
        foundOLFeature = found.olFeature
        foundOLLayer = found.olLayer

        layerOfSelectedFeature.value = foundOLLayer

        // console.log(foundData)
        // console.log(foundOLFeature)

        if (foundOLFeature) {

            if (route.name == "tracker-feature-view") {
                console.log("🌍 👀 view")
            }
            if (route.name == "tracker-feature-edit") {
                console.log("🌍 ✋ edit")
            }


            console.log("🌍 show layer if layer of foundolfeature is hidden")

            view_ref.value.setZoom(view_ref.value.getZoom() + 3)

            vectorSelectionControl.value.actions.selectFeature(foundOLFeature)



        }

        else {
            console.log("🌍 feature not found")
            return false
        }

        return true
    }

}



const manageCoords = async (coords, newZoom, epsg) => {

    // console.log("📍 remember to zoom to feature")

    // debugger
    // const coords = coordsString.split(",")

    for (let i = 0; i < coords.length; i++) {
        coords[i] = parseFloat(coords[i])
    }

    const coords3857 = transform(coords, "EPSG:" + epsg, "EPSG:3857")


    await nextTick(() => { })

    view_ref.value.setCenter(coords3857)

    let zoom = 16
    if (newZoom) {
        zoom = parseInt(newZoom)
    }

    view_ref.value.setZoom(zoom)


}


// 0
// : 
// 5069476.052011699
// 1
// : 
// 802805.0152987129

const removeFollow = (e) => {
    // console.log(e)
    if (runtimeStore?.volatile?.location?.follow === true)
        runtimeStore.setFollowFalse()
    return true
}

const onDragWhileSelected = (e) => {
    vectorSelectionControl.value.actions.clearSelection()
}



const areFeaturePropertiesEditable = (feature) => {
    if (!feature) return false
    if (!feature.get("uuid")) return false
    const data = dataStore.getDataFromFeatureUUID(feature.get("uuid"))
    if (data.node.name === "phytosociological") return true
    if (data.node.name === dataStore.trackerTodayName) return true
    return false
    // [dataStore.trackerTodayName, 'phytosociological'].includes(layerOfSelectedFeature.get('name'))
}

const isGeometryFeatureEditable = (feature) => {

    const propertiesEditable = areFeaturePropertiesEditable(feature)

    if (!propertiesEditable) return false   
    
    // if geom is lineString is not editable

    if (feature.getGeometry().getType() === "LineString") return false

    return true

}


const stepFeature = (modifier) => {

    let nextOLFeature = null

    // TODO: console.log("cambiare il check controllando chi è il layer (tracker o phyto) .... e non se ha uuid")

    if (selectedOLFeature.value.get("uuid")) {                


        const data = dataStore.getDataFromFeatureUUID(selectedOLFeature.value.get("uuid"))
        const dataFeatures = data?.node?.features
        // const features = layerOfSelectedFeature.value.get("source")?.getFeatures()
        debugger
        // console.log(data)
        if (!dataFeatures) {
            console.error("no features, argh")
            return
        }

        if (dataFeatures.length == 0) {
            console.error("no features, argh2")
        }

        const currentFeatureIndex = dataFeatures.indexOf(data.feature)
        // console.log("currentFeatureIndex", currentFeatureIndex)

        // console.log("modifier", modifier)
        const nextDataFeatureIndex = (dataFeatures.length + currentFeatureIndex + modifier) % dataFeatures.length  // modulo bug
        const nextDataFeature = dataFeatures[nextDataFeatureIndex]
        const uuid = nextDataFeature.properties.uuid


        nextOLFeature = getOLLayerAndFeatureFromUUID(uuid).olFeature
        // console.log("nextOLFeatureIndex", nextOLFeatureIndex)
        // console.log("nextOLFeatureIndex ol_uid", nextOLFeature.ol_uid)
    }

    else {
        // layer from feature

        const features = layerOfSelectedFeature.value.get("source")?.getFeatures()

        const currentFeatureIndex = features.indexOf(selectedOLFeature.value)
        // console.log("currentFeatureIndex", currentFeatureIndex)

        // console.log("modifier", modifier)
        const nextOLFeatureIndex = (features.length + currentFeatureIndex + modifier) % features.length  // modulo bug
        nextOLFeature = features[nextOLFeatureIndex]
    }

    // selectInteraction.value.select.getFeatures().clear()
    if (nextOLFeature) {
        // console.log(selectInteraction.value.select)
        vectorSelectionControl.value.actions.selectFeature(nextOLFeature)

        //centerOnFeature(view_ref, nextFeature)

        zoomToFeature(nextOLFeature)
    }
}


const prevFeature = function () {
    // console.log("actions.prevFeature")
    stepFeature(-1)
}


const nextFeature = function () {
    // console.log("actions.nextFeature")
    stepFeature(1)
}




const interactionMode = ref("select")
provide("interactionMode", interactionMode)


const editFeature = () => {
    interactionMode.value = "edit"
}

const newGeometry = async (GeoJSONGeometry) => {

    console.log("newGeometry received", GeoJSONGeometry)

    if (GeoJSONGeometry === null) {
        interactionMode.value = "select"
        return
    }

    // selectedOLFeature.value.setGeometry(geometry)
    const data = dataStore.getDataFromFeatureUUID(selectedOLFeature.value.get("uuid"))
    const uuid = data.feature.properties.uuid

    // assegno la nuova geometria alla feature
    // console.log(GeoJSONGeometry)
    // console.log(data.feature.geometry)
    data.feature.geometry = GeoJSONGeometry


    // calcolo centro e lo assegno a lon - lat
    const gExt = selectedOLFeature.value.getGeometry().getExtent()
    const midPoint =  olExtent.getCenter(gExt)

    // convert projected map coordinates back to lon/lat
    const lonLat = toLonLat(midPoint, map.value.getView().getProjection().getCode())

    data.feature.properties.lon = parseFloat(lonLat[0].toFixed(7))
    data.feature.properties.lat = parseFloat(lonLat[1].toFixed(7))

    dataStore.save()

    // source is changed!!!

    interactionMode.value = "select"

    await nextTick()
    const theVerySameFeature = getOLLayerAndFeatureFromUUID(uuid)?.olFeature
    console.log(theVerySameFeature)

    await nextTick()

    vectorSelectionControl.value.actions.selectFeature(theVerySameFeature)
}


const swipeBox = (direction, the_ref) => {

    // console.log(model)
    // const model = modelGetter()

    if (direction !== rightHandedRight.value) {
        the_ref = false
    }
    // console.log(direction)
    // console.log(rightHandedRight.value)
    // console.log(rightHandedRight.value.value)
}


</script>


<style scoped>
:deep(.ol-scale-line) {
    right: v-bind('scaleline.right') !important;
    left: v-bind('scaleline.left') !important;
    transform: v-bind('scaleline.transform') !important;
}


#the_map {
    position: relative;
    background: #000;
    display: block;
    height: 100%;
    width: 100%;
}

.v-navigation-drawer {
    z-index: 1010;
}

#controls {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1001;
    height: 100%;
    width: 100%;
    display: flex;
    pointer-events: none;
    background: transparent;
    /* background: linear-gradient(90deg, rgba(0,0,0,.5) 0%,rgba(0,0,0,0) 4%, rgba(0,0,0,0) 94%, rgba(0,0,0,.5) 100%); */
}

/* #controls>div {} */

/* #controls>div>*, */
#controls>div>* * {
    pointer-events: auto;
}

#controls>div {
    padding: 1em;
}

#controls>div>.v-card {
    margin: .2em;
}

:deep(#controls .v-btn) {
    margin: .3em;
    border: 3px solid #0005;
    /* border: 10x solid rgba(0,0,0,1); */
}

#controls .v-spacer {
    /* background-color: rgba(0, 255, 0, .3); */
    pointer-events: none;
}

#controls .left {
    /* background-color: rgba(255, 0, 0, .3); */
    pointer-events: none;
    height: 100%;
}

#controls .right {
    /* background-color: rgba(0, 0, 255, .3); */
    pointer-events: none;
    height: 100%;
}


#controls .row1,
#controls .row2,
#controls .row3 {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

#controls .row1,
#controls .row3 {
    height: 33%;
}

#controls .row1 {
    align-items: center;
    justify-content: start;
}

#controls .row2 {
    height: 34%;
    align-items: center;
    justify-content: center;
}

#controls .row3 {
    align-items: center;
    justify-content: end;
}



#x_container,
#y_container {
    z-index: 1000;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

#xaxis,
#yaxis {
    /* background-color: white; */
    /* background-color: #FFFFFF; */
    background-color: v-bind('crossColor');

}

#yaxis {
    /* width: 1px; */
    /* width: 1px; */
    width: v-bind('axisStrokeWidthPx');
    height: 100%;
    box-shadow: 1px 0px rgba(0, 0, 0, .3);
}

#xaxis {
    width: 100%;
    /* height: 1px; */
    /* height: 1px; */
    height: v-bind('axisStrokeWidthPx');
    box-shadow: 0px 1px rgba(0, 0, 0, .6);
    ;
}

#bottomSheet {
    margin: 0 !important;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1004;
}


#ribbon {
    display: none;
    height: 2em;
    width: 100%;
    z-index: 1004;
    position: fixed;
    border-width: 1em 0 0 0;
    border-style: solid;
    border-color: v-bind('possibilitaAttiva?.color || "black"');
}
</style>
